module.exports = __webpack_public_path__ + "img/ne.dcb796f0.svg";